<template>
  <div id="farm-detail">
    <v-layout align-center row wrap>
      <v-flex md4 sm6 v-if="groups" xs6>
        <v-img
          :lazy-src="require('@/assets/NoPicture.png')"
          :src="groups.picture ? groups.picture : require('@/assets/NoPicture.png')"
          aspect-ratio="1"
        ></v-img>
      </v-flex>
      <v-flex md4 sm6 v-if="groups" xs12>
        <div class="caption">ผลิตโดย</div>
        <div class="headline my-2">{{ groups.nameTha }}</div>
        <div class="caption">{{ groups.descriptionTha }}</div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: '',
  props: {
    qrcodeId: {
      type: String
    }
  },
  data() {
    return {
      groups: []
    }
  },
  async created() {
    const states = await this.fetchData()
    this.getGroups(states)
  },
  methods: {
    async fetchData() {
      try {
        const response = await this.axios.get(`cropperz/qrcode/${this.qrcodeId}`)
        return response.data[0]
      } catch (error) {
        throw new Error(error)
      }
    },
    async getGroups(states) {
      try {
        const response = await this.axios.get(`cropperz/groups/details/${states.farmId}`)
        if (response.data) {
          this.groups = response.data[0]
        }
      } catch (error) {
        throw new Error(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
